import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import apiUrl from '../../utils/apiUrl';
import AppSpinner from '../AppSpinner/AppSpinner';

const select = state => {
  return {
    token: state.auth.token
  };
};

function ConnectedNibifyComponent(props) {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);

    const dataProm = await fetch(`${apiUrl}/admin/nibify?token=${props.token}`);
    const dataResp = await dataProm.json();

    if (dataResp.success) setData(dataResp.data);

    setLoading(false);
  };

  if (loading) {
    return (    
      <div className="nibify-component">
        <AppSpinner />
      </div>
    );
  }

  return (    
    <div className="nibify-component">
      <div className="table-info-component">
        <Container>
          <Row>
            <Col>
              <h2 className="header">Usuarios Nibify</h2>
              <hr />

              <Table size="sm" striped bordered hover>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Dirección</th>
                    <th>Plan</th>
                    <th># Donaciones</th>
                    <th>Metodo Contacto</th>
                    <th>Tel</th>
                    <th>Email</th>
                    <th>Sexo</th>
                    <th>Fundación</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data.map(item =>
                      <tr key={item._id}>
                        <td>{item.userName}</td>
                        <td>{item.userAddress}, {item.userCity}{item.userAdditionalDetails ? `, ${item.userAdditionalDetails}` : ''}</td>
                        <td>{item.nibifyPlan}</td>
                        <td>{item.payments.length}</td>
                        <td>{item.contactMethod}</td>
                        <td>{item.userPhone}</td>
                        <td>{item.userEmail}</td>
                        <td>{item.userGender}</td>
                        <td>{item.foundationName}</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );

}

const NibifyComponent = connect(select)(ConnectedNibifyComponent);

export default NibifyComponent;
